"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ProductsEvent.js.map